import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Avatar } from '@mui/material';
import { StatusItemAnalise } from '../../enums/analise.enum';
export var AnaliseStatusIcon = function (_a) {
    var status = _a.status;
    if (!status) {
        return null;
    }
    if (status === StatusItemAnalise.APROVADO) {
        return _jsx(CheckCircleIcon, { sx: { color: 'success.main' } });
    }
    if (status === StatusItemAnalise.REPROVADO) {
        return _jsx(CancelIcon, { sx: { color: 'error.main' } });
    }
    return _jsx(Avatar, {});
};
